import template from './AddEditFieldsTable.html';
import FieldsTableModel from './../../lib/models/FieldsTableModel.js'

class AddEditFieldsTableVM
{
	constructor(dialog)
	{
		this.dialog = dialog;
		this.edit = this.dialog.bindings.edit;
		this.save = ko_helper.safe_observable(this.dialog.bindings.save, true);

		this.available_schemas = ko.observableArray([]);
		this.selected_schema = ko.observable();
		this.custom_schema = ko.observable('');
		this.has_default_schema = ko.observable(false);

		const defaultSchema = this.dialog.bindings.schema || this.dialog.schema?.schema || null;
		this.has_default_schema(!!defaultSchema);
		let table_data = this.dialog.bindings.fieldsTable || {};

		if (!this.edit)
		{
			let last_table_index = this.dialog.bindings.last_table_idx || 0;
			table_data.table_idx = last_table_index + 1;
		}

		if (!table_data.schema)
			table_data.schema = defaultSchema;

		this.fields_table = ko.observable(new FieldsTableModel(table_data));

		this.final_schema = ko.computed(() => {
			if (this.custom_schema() && this.custom_schema().trim() !== '')
				return this.custom_schema().trim();

			if (this.selected_schema() && this.selected_schema().schema)
				return this.selected_schema().schema;

			return this.fields_table().schema();
		});

		this.final_schema.subscribe((newSchema) => {
			this.fields_table().schema(newSchema);
		});

		// Load available schemas
		this.load_available_schemas();
	}

	async load_available_schemas()
	{
		try {
			const res = await Grape.fetches.getJSON('/api/record', {
				schema: 'fields',
				table: 'v_fields_schema',
				sortfield: 'schema'
			});

			if (res?.status === 'OK')
			{
				this.available_schemas(res.records);

				const currentSchema = this.fields_table().schema();
				const matchingSchema = res.records.find(s => s.schema === currentSchema);
				if (matchingSchema)
					this.selected_schema(matchingSchema);
			}
		} catch (error) {
			console.error('Error loading schemas:', error);
			this.available_schemas([]);
		}
	}

	btn_close_click()
	{
		this.dialog.close();
	}

	async btn_save_click()
	{
		this.fields_table().schema(this.final_schema());

		if (!this.fields_table().schema() || this.fields_table().schema().trim() === '')
		{
			Grape.alerts.alert({ type: 'warning', title: 'Validation Error', message: 'Schema name is required.' });
			return;
		}

		if (!this.fields_table().table() || this.fields_table().table().trim() === '')
		{
			Grape.alerts.alert({ type: 'warning', title: 'Validation Error', message: 'Table name is required.' });
			return;
		}

		if (this.save() === false) //return the data
			this.dialog.close({ status: 'OK', fieldsTable: this.fields_table().serialize() });
		else
		{
			// Save
			let res = await this.fields_table().save();
			if (res)
			{
				if (res?.status !== 'OK')
				{
					Grape.alerts.apiError(res);
					return;
				}

				Grape.alerts.alert({ type:'success', title:'Success', message:'Successfully Saved.' });
				this.dialog.close(res);
			}
		}
	}
}

class AddEditFieldsTableDialog
{
	constructor(bindings, element)
	{
		this.bindings = bindings || {};
		this.viewModel = new AddEditFieldsTableVM(this);
		this.name = 'AddEditFieldsTable';
	}
}

export default {
	name: 'AddEditFieldsTable',
	dialog_class: AddEditFieldsTableDialog,
	provider: 'ps',
	template: template
}
